import appCaptainInvoice from "../../views/appCustomers/index.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "captaininvoice";
  const params = ["page", "limit"];

  $stateProvider.state("captaininvoice", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appCaptainInvoice,
      },
    },
    reloadOnSearch: false,
    data: { title: "Captain Invoice" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/captainInvoice/captainInvoice.urls.js